exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_1179c1f{width:420px!important}.desc_b3ba82c{color:#999}.wrapper_3b72c49{display:inline-block;margin-left:10px}.form_item_93af727{max-width:845px}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_1179c1f",
	"desc": "desc_b3ba82c",
	"wrapper": "wrapper_3b72c49",
	"form_item": "form_item_93af727"
};